import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { ReactNode, ReactElement } from "react";

export const MaybeWhenVisibilityIsImminent = ({
  customizePlaceholder,
  shouldWrap,
  children,
}: {
  customizePlaceholder?:
    | ReactElement
    | ((contentHeight: number | undefined) => ReactElement);
  shouldWrap: boolean;
  children: ReactNode;
}) => {
  return shouldWrap ? (
    <WhenVisibilityIsImminent customizePlaceholder={customizePlaceholder}>
      {children}
    </WhenVisibilityIsImminent>
  ) : (
    <>{children}</>
  );
};
